import apiClient from '@u/apiClient.js'
import FetchNewLogActivityController from '@/wayfinder/actions/App/Http/Controllers/ActivityLog/FetchNewLogActivityController'
import FetchActivityLogsByDayController from '@/wayfinder/actions/App/Http/Controllers/ActivityLog/FetchActivityLogsByDayController'
import StoreCustomActivityLogController from '@/wayfinder/actions/App/Http/Controllers/ActivityLog/StoreCustomActivityLogController'
import UpdateCustomActivityLogController from '@/wayfinder/actions/App/Http/Controllers/ActivityLog/UpdateCustomActivityLogController'
import DeleteCustomActivityLogController from '@/wayfinder/actions/App/Http/Controllers/ActivityLog/DeleteCustomActivityLogController'
import FetchLogActivitiesController from '@/wayfinder/actions/App/Http/Controllers/ActivityLog/FetchLogActivitiesController'

export default {
  fetchNewActivityLog() {
    return new Promise((resolve, reject) => {
      apiClient
        .route(FetchNewLogActivityController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchActivityLogByDay(_context, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(FetchActivityLogsByDayController.get(), {
          params: payload.params
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  storeActivityLog(_context, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(StoreCustomActivityLogController.post(), payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateActivityLog(_context, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateCustomActivityLogController.put({ activity: payload.id }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteActivityLog(_context, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteCustomActivityLogController.delete({ activity: payload.id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchActivities: (_context, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(FetchLogActivitiesController.get(), {
          params: payload
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
